import React from 'react'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters'

interface Props {
	children: JSX.Element
}

export const ListWrapper = ({ children }: Props): JSX.Element => {
	return (
		<List>
			<ScrollWrapper>
				<ScrollMargin>
					<ListItems>{children}</ListItems>
				</ScrollMargin>
			</ScrollWrapper>
		</List>
	)
}

const List = styled.div`
	margin: 0 -16px;
`

const ScrollWrapper = styled.div`
	overflow-x: scroll;
	overflow-y: visible;
	-ms-overflow-style: none; /* Internet Explorer 10+ */
	scrollbar-width: none; /* Firefox */
	::-webkit-scrollbar {
		display: none; /* Safari and Chrome */
	}
`

const ScrollMargin = styled.div`
	display: inline-block;
	margin: 0 16px;
	width: 95%;
	${mediaQueriesByDevice.mobile} {
		width: unset;
	}
`

const ListItems = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	column-gap: 8px;
	width: 100%;
	padding: 24px 0;
	white-space: nowrap;
	${mediaQueriesByDevice.mobile} {
		grid-template-columns: 200px 200px 200px;
		justify-content: unset;
		align-items: unset;
	}
`
